export const easeOutCubic = '300ms cubic-bezier(0.215, 0.610, 0.355, 1.000)'
